<template>
  <div class="panel-selector">
    <p class="panel-selector__label overline mb-1">Cambiar panel</p>
    <v-btn-toggle
      v-model="selected"
      mandatory
      dense
      rounded
      color="#5E85EF"
      class="panel-selector__toggle"
      @change="onChange"
    >
      <v-btn
        v-for="opt in options"
        :key="opt.value"
        :value="opt.value"
        x-small
        class="panel-selector__btn"
      >
        <v-icon x-small left>{{ opt.icon }}</v-icon>
        {{ opt.text }}
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: 'PanelSelector',
  data() {
    const saved = document.cookie.match(/(^| )laot_panel=([^;]+)/)
    const fromCookie = saved ? decodeURIComponent(saved[2]) : null
    const fromStorage = typeof localStorage !== 'undefined' ? localStorage.getItem('laot_panel') : null
    return {
      selected: fromCookie || fromStorage || 'panel',
      options: [
        { text: 'Clásico', value: 'panel', icon: 'mdi-view-dashboard' },
        { text: 'Nuevo', value: 'nuevo', icon: 'mdi-new-box' }
      ]
    }
  },
  methods: {
    getPref(name = 'laot_panel') {
      try {
        if (location.hostname.includes('localhost')) {
          return localStorage.getItem(name)
        }
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
        return match ? decodeURIComponent(match[2]) : null
      } catch (e) {
        return null
      }
    },
    setPref(value, name = 'laot_panel') {
      try {
        if (location.hostname.includes('localhost')) {
          localStorage.setItem(name, value)
          return
        }
        const maxAge = 60 * 60 * 24 * 365
        let cookie = name + '=' + encodeURIComponent(value) + '; domain=.laot.cl; path=/; max-age=' + maxAge + '; SameSite=Lax'
        if (location.protocol === 'https:') cookie += '; Secure'
        document.cookie = cookie
      } catch (e) {
        /* eslint-disable no-console */
        console.warn('PanelSelector.setPref error', e)
        /* eslint-enable no-console */
      }
    },
    onChange(val) {
      this.setPref(val)
      if (location.hostname.includes('localhost')) return
      const hostMap = { panel: 'panel.laot.cl', nuevo: 'nuevo.laot.cl' }
      const targetHost = hostMap[val] || val
      if (targetHost && location.hostname !== targetHost) {
        const target = location.protocol + '//' + targetHost + location.pathname + location.search + location.hash
        window.location.href = target
      }
    }
  }
}
</script>

<style scoped>
.panel-selector {
  padding: 0;
}
.panel-selector__label {
  color: #9e9e9e;
  font-size: 9px !important;
  letter-spacing: 0.08em;
  margin-bottom: 4px;
  line-height: 1;
}
.panel-selector__toggle {
  width: 100%;
  display: flex;
}
.panel-selector__btn {
  flex: 1;
  font-size: 10px !important;
  letter-spacing: 0.02em;
}
</style>
